import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_SUPPORTED_EVENT_TYPES = 'GET_SUPPORTED_EVENT_TYPES';
export const GET_EVENT_META_DATA = 'GET_EVENT_META_DATA';

// supported event types
export const GETTING_SUPPORTED_EVENT_TYPES = 'GETTING_SUPPORTED_EVENT_TYPES';
export const GETTING_SUPPORTED_EVENT_TYPES_SUCCEEDED =
  'GETTING_SUPPORTED_EVENT_TYPES_SUCCEEDED';
export const GETTING_SUPPORTED_EVENT_TYPES_FAILED =
  'GETTING_SUPPORTED_EVENT_TYPES_FAILED';

export const getSupportedEventTypes = createAction(GET_SUPPORTED_EVENT_TYPES);
export const gettingSupportedEventTypes = createAction(
  GETTING_SUPPORTED_EVENT_TYPES
);
export const gettingSupportedEventTypesSucceeded = createAction(
  GETTING_SUPPORTED_EVENT_TYPES_SUCCEEDED
);
export const gettingSupportedEventTypesFailed = createAction(
  GETTING_SUPPORTED_EVENT_TYPES_FAILED
);

// event meta data
export const GETTING_EVENT_META_DATA = 'GETTING_EVENT_META_DATA';
export const GETTING_EVENT_META_DATA_SUCCEEDED =
  'GETTING_EVENT_META_DATA_SUCCEEDED';
export const GETTING_EVENT_META_DATA_FAILED = 'GETTING_EVENT_META_DATA_FAILED';

export const getEventMetaData = createAction(GET_EVENT_META_DATA);
export const gettingEventMetaData = createAction(GETTING_EVENT_META_DATA);

export const gettingEventMetaDataSucceeded = createAction(
  GETTING_EVENT_META_DATA_SUCCEEDED
);
export const gettingEventMetaDataFailed = createAction(
  GETTING_EVENT_META_DATA_FAILED
);
